// システム設定（portal.md「契約選択画面」の「システム設定」/ portal-api.md「システム管理者向け」）。system-admin のみ。
// issuer（プール）と audiences（App Client → 所有者）の閲覧。登録・更新はデプロイ時のレジストリ同期が行う（ADR-0018）。

import { useEffect, useState } from "react";
import { api, ApiError, messageFor, type Issuer, type Me } from "../lib/api";
import { currentUser, signIn } from "../lib/auth";
import { SystemHeader } from "./Header";

export function SystemPage() {
  const [me, setMe] = useState<Me | null>(null);
  const [issuers, setIssuers] = useState<Issuer[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      if (!(await currentUser())) { await signIn(); return; }
      try {
        const m = await api.me();
        setMe(m);
        if (m.platformRole === "system-admin") setIssuers((await api.issuers()).issuers);
      } catch (e) { setError(messageFor(e)); }
    })();
  }, []);

  if (me && me.platformRole !== "system-admin") return <main><p className="error">{messageFor(new ApiError(403, "forbidden"))}</p></main>;
  if (!me || !issuers) return <main>{error ? <p className="error">{error}</p> : <p className="muted">読み込み中…</p>}</main>;

  return (
    <>
      <SystemHeader me={me} />
      <main>
        <h1>システム設定</h1>

        <h2>issuer（プール）</h2>
        <p className="muted">
          audiences に載せた App Client のトークンだけを、その所有者（サービス・ポータル）が受理します。
          プール・App Client・会社別 SAML IdP はインフラの設定（lib/project.ts）で管理し、デプロイ時に台帳へ反映されます。
          ここでは変更できません。
        </p>
        <table>
          <thead><tr><th>プール ID</th><th>種別</th><th>Managed Login ドメイン</th><th>audiences（所有者: App Client ID）</th></tr></thead>
          <tbody>
            {issuers.length === 0 && <tr><td colSpan={4} className="muted">issuer はありません。</td></tr>}
            {issuers.map((i) => (
              <tr key={i.iss}>
                <td>{i.userPoolId}</td>
                <td>{i.poolKind === "shared" ? "共有" : "会社専用"}</td>
                <td className="muted">{i.hostedUiDomain ?? "—"}</td>
                <td className="muted">
                  {Object.entries(i.audiences).map(([id, o]) => <div key={id}>{o}: {id}</div>)}
                  {Object.keys(i.audiences).length === 0 && "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>
    </>
  );
}
